import type { IconSvgObject } from './types';

const NiqabIcon: IconSvgObject = [
  ["path", { d: "M18 8C18 4.95214 15.2046 2 12.0002 2C8.79573 2 6 4.95214 6 8C6 9.92648 4.65212 14.2463 2.57231 17.236C2.26704 17.6748 2.31363 18.2828 2.7317 18.6159C8.39492 23.128 15.6051 23.128 21.2683 18.6159C21.6864 18.2828 21.733 17.6748 21.4277 17.236C19.3479 14.2463 18 9.92648 18 8Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 5C10.3431 5 9 6.33121 9 7.97334V17C9 17.5523 9.44772 18 10 18H14C14.5523 18 15 17.5523 15 17V7.97334C15 6.33121 13.6569 5 12 5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 9H15", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 12H15", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default NiqabIcon;
